<template>
  <div>
    <el-alert
      v-if="GetDay"
      style="
        width: 280px;
        margin-bottom: 10px;
        font-size: 20px;
        background-color: tan;
      "
      title="Tomar en cuenta lo siguiente"
      description="Solo de Viernes a Domingo se podrá crear su AutoMV"
      type="warning"
      :closable="false"
      effect="dark"
      show-icon
    >
    </el-alert>
    <el-button
      type="warning"
      size="small"
      round
      icon="el-icon-plus"
      :disabled="GetDay"
      @click="CreateAutoMV"
      style="margin-bottom: 10px"
    >
      Crear
    </el-button>
    <div style="position: relative; float: right">
      <!-- FITLRO DE AÑO -->
      <el-select v-model="year" placeholder="Año" size="mini">
        <el-option
          v-for="item in years"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>

      <!-- select directionId -->
      <el-select
        v-if="this.currentUser.EmployeeId == 37"
        v-loading="loading"
        v-model="directionId"
        filterable
        clearable
        size="mini"
        placeholder="Gerencias"
      >
        <el-option
          v-for="item in directions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>

      <!-- select employeeId -->
      <el-select
        v-if="this.currentUser.EmployeeId == 37"
        v-loading="loading"
        v-model="employeeId"
        filterable
        clearable
        size="mini"
        placeholder="Colaborador"
      >
        <el-option
          v-for="item in employees"
          :key="item.EmployeeID"
          :label="item.Name"
          :value="item.EmployeeID"
        >
        </el-option>
      </el-select>

      <!-- select employeeId -->
      <el-select
        v-if="this.currentUser.EmployeeId != 37 && this.confirmRoles()"
        v-loading="loading"
        v-model="employeeId"
        filterable
        clearable
        size="mini"
        placeholder="Colaborador"
      >
        <el-option
          v-for="item in employeesByDirection"
          :key="item.EmployeeID"
          :label="item.Name"
          :value="item.EmployeeID"
        >
        </el-option>
      </el-select>
    </div>

    <div>
      <rabbey-table-3
        :loading="loading"
        :data="AutoMVData"
        :columns="AutoMVColums"
      />
    </div>

    <!-- <CreateAutoMvForm
      :openAutoMVCreation="openAutoMVCreation"
      @onClose="onAutoMVCreationFormClose"
    /> -->
    <CreateFIGMA
      :openAutoMVCreation="openAutoMVCreation"
      @onClose="onAutoMVCreationFormClose"
    />

    <AutoMvReportDetails
      :showDrawerAutoMvReport="showDrawerAutoMvReport"
      :UserId="UserId"
      :Month="Month"
      :Year="year"
      @close-autoMVDestails="CloseDetailAutoMV"
    />
  </div>
</template>

<script>
// import CreateAutoMvForm from "@/views/apps/cmi/AutoMvs/CreateForm/CreateAutoMvForm.vue";
import CreateFIGMA from "@/views/apps/cmi/AutoMvs/CreateForm/CreateFIGMA.vue";
import AutoMvReportDetails from "@/views/apps/cmi/AutoMvs/Report/AutoMvReportDetails.vue";
import { AutoMVcolumns } from "@/views/apps/cmi/AutoMvs/colums/AutoMVColums.js";
import { formatArrayToElSelect } from "@/utils";

export default {
  name: "AutoMVsReport",
  components: {
    // CreateAutoMvForm,
    AutoMvReportDetails,
    CreateFIGMA
  },
  data() {
    return {
      AutoMV: "23/01/2023",
      openAutoMVCreation: false,
      AutoMVData: [],
      AutoMVColums: AutoMVcolumns,
      employeeId: "",
      employees: [],
      employeesByDirection: [],
      directionId: "",
      directions: [],
      year: new Date().getFullYear(),
      loading: false,
      showDrawerAutoMvReport: false,
      UserId: 0,
      Month: 0,
      today: 0,
      autoMvPending: 0
    };
  },
  computed: {
    years() {
      const lowLevel = 2014;
      const currentYear = new Date().getFullYear();
      let Years = [];
      for (var i = lowLevel; i <= currentYear + 1; i++) {
        Years.push({ label: i, value: i });
      }
      return Years;
    },
    GetDay() {
      var day = new Date();
      let disable = true;
      switch (day.getDay()) {
        case 0: //Domingo
          disable = false;
          break;
        // case 1: //Lunes
        //   disable = false;
        //   break;
        // case 2: //Martes
        //   disable = false;
        //   break;
        // case 3: //Miércoles
        //   disable = false;
        //   break;
        // case 4: //Jueves
        //   disable = false;
        //   break;
        case 5: //Viernes
          disable = false;
          break;
        case 6: //Sábado
          disable = false;
          break;
        default:
          disable = true;
      }
      return disable;
    }
  },
  mounted() {
    this.GetAutoMVsByMonth();
    this.GetEmployeeBySupervisor();
    this.ValidateAutoMVPending();
    this.getEmployees();
    this.$http
      .get("/api/Directions/DirectionsByCompany", {
        params: {
          company: this.currentCompany
        }
      })
      .then(({ data }) => {
        this.directions = formatArrayToElSelect(data);
      })
      .catch(() => {});
  },
  methods: {
    CreateAutoMV() {
      if (this.autoMvPending) {
        this.$alert(
          "Tienes AutoMV pendiente por calificar, por favor pide que te califiquen y después podras crear tu nuevo AutoMV",
          "AutoMV Sin Calificar",
          {
            type: "error"
          }
        );
        return;
      }
      this.openAutoMVCreation = true;
    },
    onAutoMVCreationFormClose() {
      this.openAutoMVCreation = false;
      this.GetAutoMVsByMonth();
      this.ValidateAutoMVPending();
    },
    OpenDetailAutoMV(row, month) {
      let mtn;
      switch (month) {
        case "Enero":
          mtn = 1;
          break;
        case "Febrero":
          mtn = 2;
          break;
        case "Marzo":
          mtn = 3;
          break;
        case "Abril":
          mtn = 4;
          break;
        case "Mayo":
          mtn = 5;
          break;
        case "Junio":
          mtn = 6;
          break;
        case "Julio":
          mtn = 7;
          break;
        case "Agosto":
          mtn = 8;
          break;
        case "Septiembre":
          mtn = 9;
          break;
        case "Octubre":
          mtn = 10;
          break;
        case "Noviembre":
          mtn = 11;
          break;
        case "Diciembre":
          mtn = 12;
          break;
        default:
      }
      // console.log("qqqq", mtn)
      this.UserId = row.UserId;
      this.Month = mtn;
      // this.Year = row.year
      this.showDrawerAutoMvReport = true;
    },
    CloseDetailAutoMV() {
      this.showDrawerAutoMvReport = false;
      this.GetAutoMVsByMonth();
      this.ValidateAutoMVPending();
    },
    async GetAutoMVsByMonth() {
      // console.log("GetAutoMVsByMonth");
      this.loading = true;
      let employee = this.confirmRoles()
        ? this.employeeId != ""
          ? this.employeeId
          : 0
        : this.currentUser.EmployeeId;
      let direction =
        this.currentUser.EmployeeId == 37
          ? this.directionId != ""
            ? this.directionId
            : 0
          : this.currentUser.DireccionID;
      this.$http
        .get(
          `/api/CMI/AutoMVs/GetAutoMVsByMonth?year=${this.year}&employeeId=${employee}&directionId=${direction}`
        )
        .then((resp) => {
          this.AutoMVData = resp.data;

          this.AutoMVData.forEach((dataC) => {
            dataC.OpenDetailAutoMV = this.OpenDetailAutoMV;
          });
        })
        .catch((err) => {
          console.error("Error en GetAutoMVsByMonth: ", err);
        })
        .finally(() => (this.loading = false));
    },
    ValidateAutoMVPending() {
      this.currentUser.DireccionID;
      this.$http
        .get(
          `/api/CMI/AutoMVs/ValidateAutoMVPending?userId=${this.currentUser.UserID}`
        )
        .then((resp) => {
          this.autoMvPending = resp.data;
        })
        .catch((err) => {
          console.error("Error en GetAutoMVsByMonth: ", err);
        })
        .finally(() => (this.loading = false));
    },
    confirmRoles() {
      let rtn = this.IsInRoles([
        this.roles.GerenteDeSoporte,
        // this.roles.SuperUsuario,
        this.roles.EncargadaCompras,
        this.roles.GerenteRRHH,
        this.roles.SupervisorDeTécnicos,
        this.roles.GerenciaGeneral,
        this.roles.CoordinadorIso,
        this.roles.DirectorDeProyectos,
        this.roles.CoordinadorDeSoporte,
        this.roles.DirectorAdministrativo,
        this.roles.CoornidadorDeServicioAlCliente,
        this.roles.EncargadoDesarrolloDeAplicaciones,
        this.roles.CEO,
        this.roles.SupervisorDeSoporteDeVentas,
        this.roles.SupervisorDeVentas
      ])
        ? true
        : false;

      return rtn;
    },
    getEmployees() {
      let uri = "";
      const company = this.currentCompany;
      const employeeId = this.currentUser.EmployeeId;

      if (this.directionId > 0) {
        uri = `/api/Employees/GetEmployeeByCriteria?DepartmentID=${this.deparmentId}&DirectionID=${this.directionId}`;
      } else {
        uri = `/api/CMI/Objetives/GetUsersObjetivos?CompanySelected=${company}&employeeid=${employeeId}`;
      }

      this.$http
        .get(uri)
        .then((response) => {
          this.employees = response.data;
        })
        .catch(() => {});
    },
    GetEmployeeBySupervisor() {
      let uri = `/api/Employees/GetEmployeeByCriteriaSupervisor?employeeid=${this.currentUser.EmployeeId}`;
      this.$http
        .get(uri)
        .then((resp) => {
          if (this.currentUser.EmployeeId != 37) {
            resp.data.user.forEach((element) => {
              this.employeesByDirection.push({
                EmployeeID: element.EmployeeID
                  ? element.EmployeeID
                  : element.Id,
                Name: element.FullName ? element.FullName : element.Name
              });
            });

            resp.data.okEmployee.forEach((element) => {
              this.employeesByDirection.push({
                EmployeeID: element.EmployeeID
                  ? element.EmployeeID
                  : element.Id,
                Name: element.FullName ? element.FullName : element.Name
              });
            });
          }
        })
        .catch((err) => {
          if (err.message.includes("404")) {
            const h = this.$createElement;
            this.$message({
              type: "info",
              //message: "Cliente no encontrado, consultelo en otra empresa"
              message: h("p", null, [
                h("span", null, "Empleado no "),
                h("i", { style: "color: teal" }, "encontrado")
              ])
            });
          } else {
            this.$alert(err.message, err.name, {
              type: "error"
            });
          }
        });
    }
  },
  watch: {
    year() {
      this.GetAutoMVsByMonth();
    },
    employeeId() {
      this.GetAutoMVsByMonth();
    },
    directionId() {
      this.getEmployees();
      this.GetAutoMVsByMonth();
    },
    autoMvPending(v) {
      this.autoMvPending = v;
    }
  }
};
</script>

<style scoped></style>
